import styled from '@emotion/styled'
import { Benefits } from 'app/components/Common/Header/Benefits'
import { Image } from 'app/components/Common/Image'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import React, { memo } from 'react'

import { Syncrobox } from './Syncrobox'

export interface Props {
  modalStatus?: boolean
}

export const ModalIBE = memo(function ModalIBE({ modalStatus }: Props) {
  return (
    <Container
      className={modalStatus ? 'open' : undefined}
      dial={4}
      onClick={(e) => e.stopPropagation()}
      row
      stretch
    >
      <LeftSide dial={2}>
        {modalStatus ? (
          <Image className="item-bg" src="/syncrobox.jpg" />
        ) : null}

        <Benefits modalStatus={modalStatus} />
      </LeftSide>

      <RightSide dial={4}>
        <Syncrobox modalStatus={modalStatus} />
      </RightSide>
    </Container>
  )
})

const Container = styled(FlexBox)`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  -webkit-overflow-scrolling: auto;
  &.open {
    > div {
      transition: 0.6s ease-in-out;
      transform: none;
    }
  }

  > div {
    transition-delay: 0.6s;
  }
`

const LeftSide = styled(FlexBox)`
  width: 50%;
  background: ${({ theme }) => theme.colors.variants.neutralDark2};
  transform: translateX(-100%);
  padding: 10rem 0 0;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.colors.variants.neutralDark1};
    opacity: 0.6;
    z-index: 1;
  }

  .item-benefits {
    text-align: left;
    position: absolute;
    width: calc(100% - 13.169vw);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    margin-top: 0;

    .item-title {
      text-align: left;
    }

    .item-element {
      width: 100%;
      margin-bottom: 1.25rem;
    }
  }

  .item-bg img {
    ${styles.img}

    position: absolute !important;
  }

  @media (max-width: 1439px) {
    padding: 13.333vh 0 0;
  }

  @media (max-width: 1300px) {
    padding: 5rem 0 0;
  }
`

const RightSide = styled(FlexBox)`
  width: 50%;
  background: ${({ theme }) => theme.colors.variants.primaryDark};
  transform: translateX(100%);
  padding: 10rem 11.111vw 0;

  @media (max-width: 1439px) {
    padding: 13.333vh 7.5rem 0;
  }
  @media (max-width: 1300px) {
    padding: 5rem 7.5rem 0;
  }

  @media (max-width: 1199px) {
    display: block;
    width: 100%;
    transform: none;
  }
`
